import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

interface ClosedTradeItemProps {
  data: {
    close_time: string
    symbol: string
    side: 'buy' | 'sell' | string
    volume: number
    net_profit: number
    commission: number
    swap: number
    profit_gross: number
    balance_after: number
    pips: number
    history_id?: string
  }
}

const ClosedTradeItem = (props: ClosedTradeItemProps) => {

  const { data } = props
  const { t } = useTranslation();

  const [getDate, setGetDate] = useState<string>('')
  const [getTime, setGetTime] = useState<string>('')

  function formatFullDate(input: string) {
    const date = new Date(input);

    if (isNaN(date.getTime())) return "";

    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    setGetDate(`${day} ${month} ${year}`);
    setGetTime(`${hours}:${minutes}:${seconds}`)
  }

  function secondsToHHMMSS(totalSeconds: number): string {
    if (isNaN(totalSeconds) || totalSeconds < 0) return "00:00:00";

    const total = Math.floor(totalSeconds);

    const days = Math.floor(total / 86400);
    const hours = Math.floor((total % 86400) / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;

    const pad = (n: number) => n.toString().padStart(2, "0");
    const timePart = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;

    return days > 0 ? `${days}d ${timePart}` : timePart;
  }

  useEffect(() => {
    formatFullDate(data.close_time)
  }, [data])

  return (
    <tr>
      <td style={{ width: '160px', minWidth: '160px' }}>
        <div className="text-labels-medium text-content-primary">
          {getDate}<br />
          {getTime}</div>
      </td>
      <td style={{ width: '140px', minWidth: '120px' }}>
        <div className="text-labels-medium text-content-primary">{data.symbol}</div>
      </td>
      <td style={{ width: '100px', minWidth: '90px' }}>
        <div className={`inline-flex items-center px-2 py-1 rounded-full text-labels-small ${['mua', 'buy'].includes(String(data.side).toLowerCase())
            ? 'bg-green-100 text-functional-success'
            : 'bg-red-100 text-functional-danger'
          }`}>
          {['mua', 'buy'].includes(String(data.side).toLowerCase()) ? t('Buy') : t('Sell')}
        </div>
      </td>
      <td style={{ width: '100px', minWidth: '90px' }}>
        <div className="text-labels-medium text-content-primary">{Number(data.volume).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
      </td>
      <td style={{ width: '140px', minWidth: '120px' }}>
        <div className={`text-labels-medium ${data.net_profit < 0 ? 'text-functional-danger' : 'text-functional-success'}`}>{data.net_profit < 0 ? '-' : ''}${Number(Math.abs(data.net_profit)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}{data.net_profit < 0 ? '' : ''}</div>
      </td>
      {/* <td style={{ width: '120px', minWidth: '100px' }}>
        <div className="text-labels-medium text-content-primary">${Number(data.commission).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
      </td>
      <td style={{ width: '120px', minWidth: '100px' }}>
        <div className="text-labels-medium text-content-primary">${Number(data.swap).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
      </td> */}
      <td style={{ width: '140px', minWidth: '120px' }}>
        <div className={`text-labels-medium ${data.profit_gross < 0 ? 'text-functional-danger' : 'text-functional-success'}`}>{data.profit_gross < 0 ? '-' : ''}${Number(Math.abs(data.profit_gross)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
      </td>
      <td style={{ width: '160px', minWidth: '140px' }}>
        <div className="text-labels-medium text-content-primary">${Number(data.balance_after).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
      </td>
      <td style={{ width: '100px', minWidth: '90px' }}>
        <div className={`${data.pips < 0 ? 'text-functional-danger' : 'text-functional-success'} text-labels-medium`}>{Number(data.pips).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
      </td>
    </tr>
  )
}

export default ClosedTradeItem